import { call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get statistics vessel positions
 * */
export function* getStatisticsVesselPositions(from, until) {
    const response = yield call(api.getStatisticsVesselPositions, from, until);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_STATISTICS_VESSEL_POSITIONS.SUCCESS,
            data: response.data,
        });
    }

    yield put({
        type: actionTypes.GET_STATISTICS_VESSEL_POSITIONS.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetStatisticsVesselPositions() {
    while (true) {
        const { from, until } = yield take(actionTypes.GET_STATISTICS_VESSEL_POSITIONS.REQUEST);
        yield call(getStatisticsVesselPositions, from, until);
    }
}

export default [
    watchGetStatisticsVesselPositions,
]


// WEBPACK FOOTER //
// ./app/sagas/statistics/vesselPositions.js